import { getLocale } from "../runtime";

const sv_clearfilters = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rensa filter`
};

const clearfilters = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_clearfilters(inputs)
	return "clearFilters";
};

export { clearfilters as "clearFilters" };